import { Component, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TraineeListService } from "../../service/trainee-list.service";
import { TraineeSummary } from "../../model/rolePlay.model";
import { MatSort, Sort } from '@angular/material/sort';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { RoleplayApiService } from '../../service/roleplay.service';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

@Component({
    selector: "app-trainee-detail",
    templateUrl: "./trainee-detail.component.html",
    styleUrl: "./trainee-detail.component.scss",
    standalone: false
})
export class TraineeDetailComponent {
  wwidParam: number = 0;
  traineeDetails: TraineeSummary;
  userId: number = 0;
  filterValue: string;
  time: string = '';  
  formattedTime: string = '';  
  in1: string = '';
  in2: string = '';
  in3: string = '';
  in4: string = '';
  EditBalance:boolean = false;
  dataSource: any = new MatTableDataSource();
  dataSource1: any = new MatTableDataSource();
  showNoSearchResultsMessage: boolean = false;
  avatarForm: FormGroup;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('paginator') paginator: MatPaginator;
  @ViewChild('paginator1') paginator1: MatPaginator;

  displayedColumns: string[] = ['chat_type', 'chat_start_time', 'total_minutes', 'chat_name', 'status', 'trainer_feedback']; // 'session_roleplay_scores',

  displayedColumns1: string[] = ['chat_type', 'chat_start_time', 'chat_name'];
  allotedParam: number;
  pendingParam: number;
  avatarStatus: string;
  allotedTime: number =0;
  Id: any;
  PendingTime: number =0;
  balanceTime: number =0;
  getResponse: boolean = false;

  constructor(public Router: Router, private activateRoute: ActivatedRoute,
    public TraineeService: TraineeListService, private fb: FormBuilder, private _liveAnnouncer: LiveAnnouncer, private rolePlayService: RoleplayApiService) { }

  backbutton() {
    this.Router.navigate(["/app-trainee-list"], { skipLocationChange: true });
  }
  
  ngOnInit() {
    this.userId = Number(sessionStorage.getItem('userId'));
    this.wwidParam = Number(this.activateRoute.snapshot.queryParamMap.get('id'));
    this.allotedParam = Number(this.activateRoute.snapshot.queryParamMap.get('alloted'));
    this.pendingParam = Number(this.activateRoute.snapshot.queryParamMap.get('pending'));
    this.getUserSummary();
    this.getUserAssignedSummary();
    this.getAvatarQuota();
    this.dataSource1.paginator = this.paginator1;
    this.avatarForm = this.fb.group({
      avatar: [false, Validators.required],
    });
  }
  ngAfterViewInit() {
    this.dataSource1.paginator = this.paginator1;
    this.dataSource.paginator = this.paginator;
  }
  applyFilter(value: string) {
    this.filterValue = value.trim().toLowerCase();
    this.dataSource.filter = this.filterValue;
    if (this.dataSource.filteredData.length === 0 && this.filterValue !== '') {
      this.showNoSearchResultsMessage = true;
    } else {
      this.showNoSearchResultsMessage = false; 
    }
  }
  getUserSummary() {
    this.TraineeService.getTraineeSummaryById(this.wwidParam).subscribe((response: TraineeSummary) => {
      this.traineeDetails = response[0];
      this.dataSource = new MatTableDataSource(response[0].user_session_list);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;    
    });
  }
  getUserAssignedSummary() {
    this.TraineeService.getTraineeRolePlaySummaryById(this.wwidParam).subscribe((response: any) => {

      if (response.length) {
      this.dataSource1 = new MatTableDataSource(response);
    } else {
      this.showNoSearchResultsMessage = false;
    }
    
    this.dataSource1.paginator = this.paginator1;
    });
  }
  getAvatarQuota(){
      this.TraineeService.getavatarTimeAllocation(this.wwidParam).subscribe((res) => {
        if(res != null){
        this.allotedTime = +(((res.allocated_time)/3600).toFixed(2));
        this.PendingTime = +(((res.pending_time)/3600).toFixed(2));
        this.balanceTime = +((this.allotedTime - this.PendingTime).toFixed(2));
        this.avatarStatus = res.status;
        this.Id = res.id;
        if(this.avatarStatus == "Y"){
          this.avatarForm.get('avatar').setValue(true);
        }else{
          this.avatarForm.get('avatar').setValue(false);
        }
        this.AllottedFormat(res.pending_time);
      }else{
this.getResponse = true;
      }
        });
      
  }
  AllottedFormat(seconds){
      const hours = Math.floor(seconds / 3600);
      const remainingSeconds = seconds % 3600;
      const minutes = Math.floor(remainingSeconds / 60);
      const formattedTime = `${hours.toString().padStart(2, '0')}${minutes.toString().padStart(2, '0')}`;
      
  const digits = formattedTime;

        this.in1 = digits[0];
        this.in2 = digits[1];
        this.in3 = digits[2];
        this.in4 = digits[3];
  }
  formatTime(totalMinutes: number, remainingSeconds: number): string {
    const totalSeconds = (totalMinutes * 60) + remainingSeconds;
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
  
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }
  
  sortData(sort: Sort) {
    if (sort.direction) {
      this._liveAnnouncer.announce(`Sorted ${sort.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  userinfo(wwid: number, status: string) {
    this.Router.navigate(['/app-user-assigned-roleplay'], { skipLocationChange: true, queryParams: {id: wwid, status: status} });
  }

  cardClickHandler(chat_session_id: any) {
    this.Router.navigate([`app-trainer-assigned-roleplay`, chat_session_id, this.wwidParam, this.traineeDetails.first_name, this.traineeDetails.last_name], { skipLocationChange: true });
 }
  onTimeChange(): void {
    if (this.time) {
      // Capturing the time in HH:MM format
      this.formattedTime = this.time;
    }
  }

  moveToNext(event: any, current: number) {
    const nextInput = document.querySelector(`input:nth-of-type(${current + 1})`);
    if (nextInput && event.target.value) {
      (nextInput as HTMLInputElement).focus();
    }
  }

  EditAvatarTime(){
    this.EditBalance = true;
  }
  submitI() {
    if(this.in1===''){this.in1 = '0'};
    if(this.in2===''){this.in2 = '0'};
    if(this.in3===''){this.in3 = '0'};
    if(this.in4===''){this.in4 = '0'};

    const Hr = `${this.in1}${this.in2}`;
    const min =`${this.in3}${this.in4}`;
    const sec = parseInt(Hr)*3600+parseInt(min)*60;
    this.EditBalance = false;
    if(this.avatarForm.value.avatar == true){
      this.avatarStatus = "Y"
    }else{
      this.avatarStatus = "N"
    }
    let ReqData = {
      "user_id": this.wwidParam,
      "allocated_time": sec,
      "created_by": this.userId,
      "status": this.avatarStatus,
    } ;
    if(this.allotedParam == 0 && this.pendingParam == 0 && this.getResponse){
      this.TraineeService.createAvatarAllocation(ReqData).subscribe((res: any) => {
        this.allotedTime = +(((res.allocated_time)/3600).toFixed(2));
        this.PendingTime = +(((res.pending_time)/3600).toFixed(2));
        this.balanceTime = +((this.allotedTime - this.PendingTime).toFixed(2));
        this.avatarStatus = res.status;
        this.Id = res.id;
        if(this.avatarStatus == "Y"){
          this.avatarForm.get('avatar').setValue(true);
        }else{
          this.avatarForm.get('avatar').setValue(false);
        }
        this.AllottedFormat(res.pending_time);
      });

    }else{
      this.TraineeService.updateAvatarAllocation(this.Id,ReqData).subscribe((res: any) => {
        this.allotedTime = +(((res.allocated_time)/3600).toFixed(2));
        this.PendingTime = +(((res.pending_time)/3600).toFixed(2));
        this.balanceTime = +((this.allotedTime - this.PendingTime).toFixed(2));
        this.avatarStatus = res.status;
        this.Id = res.id;
        if(this.avatarStatus == "Y"){
          this.avatarForm.get('avatar').setValue(true);
        }else{
          this.avatarForm.get('avatar').setValue(false);
        }
        this.AllottedFormat(res.pending_time);
      });

    }

  }
}
